// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_PnxZW {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._assistantButton_qI-mb {
  --assistant-button-color: var(--color-element-assistant, linear-gradient(238deg, #A569D3 12%, #00679E 39%, #422083 86%));
  --assistant-button-background-color: var(--color-background-assistant, #F6F5FF);
  background-image: var(--color-border-assistant, linear-gradient(125deg, #7398FE 50%, #6104A4 125%));
  border-radius: var(--border-radius-element);
  height: var(--default-clickable-area);
  width: fit-content;
  padding-inline: 1px;
  padding-block: 1px 2px;
}
._assistantButton_disabled_2SHN3 {
  filter: saturate(0.5);
  opacity: 0.5;
}
._assistantButton_primary_88bJD {
  --assistant-button-color: white;
  --assistant-button-background-color: var(--color-element-assistant,linear-gradient(238deg, #A569D3 12%, #00679E 39%, #422083 86%));
}
._assistantButton_primary_88bJD ._assistantButton__icon_dXV8S,
._assistantButton_primary_88bJD ._assistantButton__text_smmL1 {
  color: white !important;
}
._assistantButton__button_mGJQY {
  --button-size: calc(var(--default-clickable-area) - 3px) !important;
  background-color: var(--assistant-button-background-color) !important;
  background-image: var(--assistant-button-background-color) !important;
  border: none !important;
}
._assistantButton__button_mGJQY:hover {
  filter: brightness(120%);
}
._assistantButton__text_smmL1 {
  background-image: var(--assistant-button-color);
  color: transparent !important;
  background-clip: text;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAssistantButton-C6d88UPB.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,wHAAwH;EACxH,+EAA+E;EAC/E,mGAAmG;EACnG,2CAA2C;EAC3C,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,kIAAkI;AACpI;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,mEAAmE;EACnE,qEAAqE;EACrE,qEAAqE;EACrE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,+CAA+C;EAC/C,6BAA6B;EAC7B,qBAAqB;AACvB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_PnxZW {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._assistantButton_qI-mb {\n  --assistant-button-color: var(--color-element-assistant, linear-gradient(238deg, #A569D3 12%, #00679E 39%, #422083 86%));\n  --assistant-button-background-color: var(--color-background-assistant, #F6F5FF);\n  background-image: var(--color-border-assistant, linear-gradient(125deg, #7398FE 50%, #6104A4 125%));\n  border-radius: var(--border-radius-element);\n  height: var(--default-clickable-area);\n  width: fit-content;\n  padding-inline: 1px;\n  padding-block: 1px 2px;\n}\n._assistantButton_disabled_2SHN3 {\n  filter: saturate(0.5);\n  opacity: 0.5;\n}\n._assistantButton_primary_88bJD {\n  --assistant-button-color: white;\n  --assistant-button-background-color: var(--color-element-assistant,linear-gradient(238deg, #A569D3 12%, #00679E 39%, #422083 86%));\n}\n._assistantButton_primary_88bJD ._assistantButton__icon_dXV8S,\n._assistantButton_primary_88bJD ._assistantButton__text_smmL1 {\n  color: white !important;\n}\n._assistantButton__button_mGJQY {\n  --button-size: calc(var(--default-clickable-area) - 3px) !important;\n  background-color: var(--assistant-button-background-color) !important;\n  background-image: var(--assistant-button-background-color) !important;\n  border: none !important;\n}\n._assistantButton__button_mGJQY:hover {\n  filter: brightness(120%);\n}\n._assistantButton__text_smmL1 {\n  background-image: var(--assistant-button-color);\n  color: transparent !important;\n  background-clip: text;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
